type IconFacebookProps = {
    className?: string;
};

export function IconFacebook(props: IconFacebookProps) {
    const { className = '' } = props;
    return (
        <svg
            aria-hidden={true}
            className={`${className}`}
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12.9228 24.4855V13.7371H16.5216L17.0604 9.54817H12.9228V6.87373C12.9228 5.66093 13.2587 4.83438 14.9935 4.83438L17.2062 4.83344V1.08692C16.8234 1.03596 15.51 0.921875 13.982 0.921875C10.792 0.921875 8.60797 2.87397 8.60797 6.45899V9.54817H5V13.7371H8.60797V24.4855H12.9228Z"
                fill={'black'}
            />
        </svg>
    );
}

export default IconFacebook;
